import { safePercent } from '../../../helpers/utils'

export function buildRouteKpiValues(data, availableActivities = []) {
  const planned = data?.total_in_route_clients
  const visited = data?.total_visited_in_route_clients
  return {
    geofence: data?.geofence,
    availableActivities,
    planned,
    visited,
    unvisited: planned != null && visited != null ? Math.max(0, planned - visited) : null,
    outside: data?.out_of_route_clients,
    totalVisited: data?.total_visited_clients,
    effectiveness:
      planned != null && visited != null ? safePercent(Number(visited), Number(planned)) : null
  }
}

export function buildActivityEffectivenessValues(data, segment = 'general') {
  const values = data?.activity_effectiveness?.[segment]
  if (!values) {
    return {
      planned: 0,
      attendedInRoute: 0,
      unattended: 0,
      outside: 0,
      totalAttended: 0,
      effectiveness: 0
    }
  }

  const planned = Number(values.planned_clients ?? 0)
  const attendedInRoute = Number(values.attended_in_route_clients ?? 0)
  const totalAttended = Number(values.total_attended_clients ?? 0)
  // Efectividad = (clientes únicos atendidos en ruta / meta del periodo) × 100.
  // Los atendidos fuera de ruta se muestran en el total, pero no suman al porcentaje.
  // Se limita a 100%; con meta cero o valores inválidos se devuelve 0%.
  // La tarjeta redondea al entero más cercano al mostrarlo (41.67% → 42%).
  const effectiveness =
    Number.isFinite(planned) && Number.isFinite(attendedInRoute) && planned > 0
      ? Math.min(100, Math.max(0, (attendedInRoute / planned) * 100))
      : 0

  return {
    planned,
    attendedInRoute,
    unattended: Number(values.unattended_in_route_clients ?? 0),
    outside: Number(values.attended_out_of_route_clients ?? 0),
    totalAttended,
    effectiveness
  }
}

export const VISIT_KPI_FILTERS = {
  planned: { label: 'Clientes en ruta (Meta)', query: 'in_route=true' },
  visited: {
    label: 'Clientes visitados en ruta',
    query: 'status=visited&in_route=true'
  },
  unvisited: {
    label: 'Clientes sin visitar',
    query: 'status=no_visited,pending,no_location&in_route=true'
  },
  outside: { label: 'Visitados fuera de ruta', query: 'status=visited&in_route=false' }
}

export const ACTIVITY_EFFECTIVENESS_KPI_FILTERS = {
  planned: { label: 'Clientes en ruta (Meta)', bucket: 'planned' },
  attendedInRoute: { label: 'Atendidos en ruta', bucket: 'attended_in_route' },
  unattended: { label: 'Clientes sin atender', bucket: 'unattended' },
  outside: { label: 'Atendidos fuera de ruta', bucket: 'outside' }
}
